import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { usePmsTheme } from "../Components/PmsThemeContext";
import { getDemoCopy } from "./demoI18n";
import { DEMO_BUSINESS_UNIT_ID, startDemoSession } from "./demoMode";
import { loadDemoSnapshot } from "./demoSnapshot";

export default function DemoEntry() {
  const [ready, setReady] = useState(false);
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const { languageId } = usePmsTheme();
  const copy = getDemoCopy(languageId);

  useEffect(() => {
    let active = true;
    setFailed(false);
    loadDemoSnapshot().then(() => {
      if (!active) return;
      startDemoSession();
      setReady(true);
    }).catch(() => {
      if (active) setFailed(true);
    });
    return () => { active = false; };
  }, [attempt]);

  if (ready) {
    return (
      <Navigate
        to={`/reservations/dashboard?business_unit_id=${DEMO_BUSINESS_UNIT_ID}`}
        replace
      />
    );
  }

  return (
    <main className="demoEntry" aria-live="polite">
      <img
        src={`${process.env.PUBLIC_URL}/Isotipo_Pilcore_Blanco.svg`}
        alt="Pilcore"
        className="demoEntry__logo"
      />
      {!failed && <div className="demoEntry__loader" aria-hidden="true" />}
      <p role={failed ? "alert" : undefined}>{failed ? copy.loadError : copy.preparing}</p>
      {failed && <button className="demoEntry__retry" onClick={() => setAttempt((value) => value + 1)}>{copy.retry}</button>}
      <style>{`
        .demoEntry {
          min-height: 100vh;
          display: grid;
          place-content: center;
          justify-items: center;
          gap: 18px;
          background: #223a7a;
          color: #fff;
          font-family: "Montserrat", sans-serif;
        }
        .demoEntry__logo { width: 82px; height: 82px; object-fit: contain; }
        .demoEntry__loader {
          width: 28px;
          height: 28px;
          border: 3px solid rgba(255,255,255,.28);
          border-top-color: #3db6e9;
          border-radius: 50%;
          animation: demoEntrySpin 700ms linear infinite;
        }
        .demoEntry p { margin: 0; font-size: .9rem; font-weight: 700; }
        .demoEntry__retry { border: 0; border-radius: 8px; padding: 10px 20px; background: #3db6e9; color: #172653; font: inherit; font-weight: 700; cursor: pointer; }
        @keyframes demoEntrySpin { to { transform: rotate(360deg); } }
      `}</style>
    </main>
  );
}
